import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import ErrorPage from "./error_page/errorPage";
import Converter from './navbar/converter';
import Redirect from './navbar/redirect';
import Home from './home_page/home';
import Footer from './footer/footer';
import CoursePage from './course_page/coursePage';
import InstructorPage from './instructor_page/instructorPage';
import AboutUsPage from './about_us_page/aboutUsPage';
import CoursesPage from './courses_page/coursesPage';
import ContactUsPage from './contact_us/contact_us';
import LoginPage from './login_page/login_page';
import './index.css';
import Cart from './cart_page/cart';
import RegisterPage from './register_page/register';
import EditCourse from './editCourse_page/edit_course';
import UploadMeetingsPage from './dashboard/upcomingMeetings.jsx';
import InteractiveBook2 from './free_materials/book2.jsx'
// import ReactGA from "react-ga4";
import TagManager from 'react-gtm-module';

import {
  BrowserRouter,
  Navigate,
  Routes,
  Route,
  Outlet,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { StyledEngineProvider } from '@mui/system';
import Dashboard from './dashboard/dashboard';
import ZoomPage from './dashboard/zoomPage';
import ChatUI from './dashboard/chatPage';
import RequestMeeting from './course_page/requestMeeting';
import Successful from './cart_page/successfulPayment.jsx';
import ChooseCartOrMeetingRequest from './course_page/choosePage.jsx';
import RequestForMeetingAccept from './course_page/requestAccept.jsx';
import InstructorsPage from './instructors_page/instructor.jsx';
import EnrolledCourse from './course_page/enrolledCourse.jsx';
import MaterialsPage from './dashboard/materials.jsx';
import ComingSoonPage from './error_page/comingSoon.jsx';
import SomethingWentWrongPage from './error_page/somethingWentWrong.jsx';
import SavedCoursesPage from './navbar/savedCourses.jsx';
import LoadingPage from './error_page/loadingPage.jsx';
import { AuthProvider, useAuth } from './context/AuthContext';
import ImpersonationBanner from './components/impersonationBanner';
import { ProtectedRoute } from './context/ProtectedRoute';
import { ProtectedAdminRoute } from './context/ProtectedAdminRoute';
import { CartProvider } from './context/CartContext';
import CourseSwitch from './course_page/courseSwitch';
import TermsAndConditionsPage from './webiste_policy/termsAndConditions.jsx';
import PrivacyPolicyPage from './webiste_policy/privacyPolicy.jsx';
import CookiePolicy from './webiste_policy/cookiePolicy.jsx';
import RefundPolicyPage from './webiste_policy/refundPolicy.jsx';
import DateTimePage from './course_page/chooseDateTime.jsx';
import SuccessfulRegistrationPage from './register_page/successfulRegistration.jsx';
import ForgottenPassPage from './login_page/forgottenPass.jsx';
import ErrorPayment from './error_page/errorPayment.jsx';
import CookieBanner from './google_tag/cookie_banner.jsx';
import ChangePass from './login_page/changePass.jsx';
import AdminDashboard from './admin/dashboard.jsx';
import { triggerGTMMEtaPixel } from './google_tag/gtm';
import EditPage from './admin/edit_profile.jsx';
import EditCourseAdmin from './admin/edit_course.jsx';
import Unsubscribe from './admin/marketing_email_unsubscribe.jsx';
import MarketingEmailView from './admin/marketing_email_view.jsx';
import ExamQuizPage from './exam_quiz';
import ExamPage from './exam_page';
import ExamSessionPage from './exam_session';
import InstructorForm from './new_instructor_form/new_instructor.jsx';
import SuccessfulForm from './new_instructor_form/successful_form.jsx';
import CompetitionsPage from './events_page/competitions/competitions.jsx';
import CompetitionPage from './events_page/competitions/competition.jsx';
import RequestParticipation from './events_page/competitions/requestParticipation.jsx';
import SummerSchoolPage from './events_page/summer_school/summer_school.jsx';
import SummerSchoolCheckoutPage from './events_page/summer_school/summer_school_checkout.jsx';
import WebinarsPage from './events_page/webinars/webinars.jsx';
import WebinarDetailPage from './events_page/webinars/webinar.jsx';
import EditWebinar from './editWebinar_page/edit_webinar.jsx';
// import globals from './globals';

// Google Analytics
// ReactGA.initialize(globals.googleAnalyticsId);
// console.log(globals.googleAnalyticsId);

const tagManagerArgs = {
  gmtId: "GTM-K92584NX",
}

TagManager.initialize(tagManagerArgs);

const NavLayout = () => {
  const { loading } = useAuth();
  useEffect(() => {
    triggerGTMMEtaPixel();
  }, []);
  return (
    <>
      <Converter />
      <div id='topGradient'></div>
      {loading ? <LoadingPage /> : <Outlet />}
      <div id='bottomGradient'></div>
      <CookieBanner />
      <Footer />

    </>

  );
}

const ProfileRoute = () => {
  const { user, token } = useAuth();

  if (!user && !token) return <Navigate to="/login" replace />;
  if (user?.role?.toLowerCase() === "admin") return <Navigate to="/admin-dashboard" replace />;

  return <Navigate to="/dashboard" replace />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <BrowserRouter>
        <CartProvider>
          <AuthProvider>
            <ImpersonationBanner />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/success-reg" element={<SuccessfulRegistrationPage />} />
              <Route path="/success-form" element={<SuccessfulForm />} />
              {/* <Route path="/success" render={(props)=><Successful {...props}/> } /> */}

              <Route path="/success" element={<Successful />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/marketing-email/:sessionId" element={<MarketingEmailView />} />


                {/* Admin pages — single guard for all routes under /admin-* */}
                <Route element={<ProtectedAdminRoute />}>
                  <Route path="/admin-dashboard" element={<AdminDashboard />} />
                  <Route path="/admin-edit-profile/:instructorId" element={<EditPage />} />
                  <Route path="/admin-edit-course/:courseId" element={<EditCourseAdmin />} />
                  <Route path="/admin-add-zoom" element={<ZoomPage adminCreate />} />
                  <Route path="/admin-edit-zoom/:meetingId" element={<ZoomPage />} />
                  <Route path="/admin-edit-webinar" element={<EditWebinar />} />
                  <Route path="/admin-edit-webinar/:webinarId" element={<EditWebinar />} />
                </Route>

              <Route element={<NavLayout />}>
                <Route path="/change-pass" element={<ForgottenPassPage />} />
                <Route path="/pass-link" element={<ChangePass />} />
                <Route path="/" element={<Home />} />
                <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
                <Route path="/choose/:id" element={<ProtectedRoute><ChooseCartOrMeetingRequest /></ProtectedRoute>} />
                <Route path="/date-time/:id" element={<ProtectedRoute><DateTimePage /></ProtectedRoute>} />
                {/* <Route path="/course" element={<CoursePage />} /> */}
                {/* <Route path="/enrolled" element={<EnrolledCourse />} /> */}
                <Route path="/course/:id" element={<CourseSwitch />} />
                <Route path="/request/:id" element={<ProtectedRoute><RequestMeeting /> </ProtectedRoute>} />
                <Route path="/request-accept" element={<RequestForMeetingAccept />} />
                <Route path="/instructor/:id" element={<InstructorPage />} />
                <Route path="/instructors" element={<InstructorsPage />} />
                <Route path="/about-us" element={<AboutUsPage />} />
                <Route path="/new-instructor" element={<InstructorForm />} />

                <Route path="/courses/:category?" element={<CoursesPage />} />
                <Route path="/saved" element={<ProtectedRoute><SavedCoursesPage /></ProtectedRoute>} />

                <Route path="/exam-quiz" element={<ExamQuizPage />} />
                <Route path="/exams/:id" element={<ExamPage />} />

                <Route path="/exams/:examId/:sessionId" element={<ExamSessionPage />} />
                <Route path="/redirect" element={<Redirect />} />
                <Route path="/zheravko-dragomanski-2" element={<InteractiveBook2 />} />
                {/* <Route path="/archive" element={<Archive />}/> */}
                {/* <Route path="/events" element={<EventsPage />}/> */}
                {/* <Route path="/free-materials" element={<FreeMaterialsPage />}/> */}
                <Route path="/competitions" element={<CompetitionsPage />} />
                <Route path="/competition" element={<CompetitionPage />} />
                <Route path="/webinars" element={<WebinarsPage />} />
                <Route path="/webinar/:slug" element={<WebinarDetailPage />} />
                <Route path="/participation" element={<ProtectedRoute><RequestParticipation /></ProtectedRoute>} />
                
                <Route path="/summer-school" element={<SummerSchoolPage />} />
                <Route path="/summer-school/checkout" element={<ProtectedRoute><SummerSchoolCheckoutPage /></ProtectedRoute>} />

                {/* <Route path="/create-course" element={<CreateCoursePage />}/> */}
                < Route path="*" element={< ErrorPage />} />
                < Route path="/coming-soon" element={< ComingSoonPage />} />
                < Route path="/something-went-wrong" element={< SomethingWentWrongPage />} />
                < Route path="/loading" element={< LoadingPage />} />
                < Route path="/error-pay" element={< ErrorPayment />} />


                {/* Students and Teachers Handling Pages */}
                < Route path="/register" element={< RegisterPage />} />
                < Route path="/dashboard" element={< ProtectedRoute > <Dashboard isInstructor={true} /></ProtectedRoute >} />
                < Route path="/edit-course" element={< ProtectedRoute > <EditCourse /></ProtectedRoute >} />
                < Route path="/meeting/:id/:student_id" element={< ProtectedRoute > <ZoomPage /></ProtectedRoute >} />
                < Route path="/upcoming-meetings" element={< ProtectedRoute > <UploadMeetingsPage /></ProtectedRoute >} />
                < Route path='/chat/:id' element={< ProtectedRoute > <ChatUI /></ProtectedRoute >} />
                < Route path="/materials/:id/:student_id" element={< ProtectedRoute > <MaterialsPage /></ProtectedRoute >} />
                {/* <Route path="/account/teacher" element={<Account />} /> */}

                {/* <Route path="/discount" element={<DiscountPage />}/> */}
                < Route path="/contact-us" element={< ContactUsPage />} />

                {/* Terms and policies */}
                < Route path="/terms-and-conditions" element={< TermsAndConditionsPage />} />
                < Route path="/privacy-policy" element={< PrivacyPolicyPage />} />
                < Route path="/cookies" element={< CookiePolicy />} />
                < Route path="/refund-policy" element={< RefundPolicyPage />} />

              </Route >
            </Routes >
          </AuthProvider >
        </CartProvider >
      </BrowserRouter >
    </StyledEngineProvider >
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
